import { Stack as MuiStack, type StackProps } from '@mui/material';

export const Stack = (props: StackProps) => <MuiStack {...props} />;
